import { useEffect, useRef, type ReactNode } from 'react';

interface DrawerProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}

export function Drawer({ open, onClose, children }: DrawerProps) {
  const panelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  return (
    <>
      <div
        className={`drawer-v2__backdrop${open ? ' drawer-v2__backdrop--open' : ''}`}
        onClick={onClose}
      />
      <div
        ref={panelRef}
        className={`drawer-v2__panel${open ? ' drawer-v2__panel--open' : ''}`}
      >
        <div className="drawer-v2__handle" />
        <div className="drawer-v2__body">
          {children}
        </div>
      </div>
    </>
  );
}
